import { render } from "./BillingManagement.vue?vue&type=template&id=f0323750&scoped=true"
import script from "./BillingManagement.vue?vue&type=script&lang=js"
export * from "./BillingManagement.vue?vue&type=script&lang=js"

import "./BillingManagement.vue?vue&type=style&index=0&id=f0323750&lang=css"
import "./BillingManagement.vue?vue&type=style&index=1&id=f0323750&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0323750"]])

export default __exports__